// frontend/src/components/TopBar/TopBar.js
import React from "react";
import "./TopBar.css";

/**
 * TopBar
 *
 * Props (kombinerat från båda versionerna)
 * ----------------------------------------
 * • templates, selectedTemplate, loadingTemplates, onTemplateChange
 * • microphones, selectedMicId, onChangeMic
 * • captureSystemAudio, onToggleSystemAudio
 * • showTemplateDropdown  (bool, default true)
 * • showSystemAudioControl (bool, default true)
 *
 * • tabs        : array<string>            — flik-id:n
 * • docTabs     : [{ docId, title }]       — titlar för dokumentflikar
 * • showTabs    : bool
 * • activeTab   : string
 * • onTabChange(id)
 *
 * • showStopButton : bool
 * • onStopRecording()
 */
const TopBar = ({
  /* mall + ljud */
  templates = [],
  selectedTemplate = null,
  loadingTemplates = false,
  onTemplateChange = () => {},
  microphones = [],
  selectedMicId = "",
  onChangeMic = () => {},
  captureSystemAudio = false,
  onToggleSystemAudio = () => {},

  /* visnings-flaggor */
  showTemplateDropdown = true,
  showTabs = false,
  showStopButton = false,
  showSystemAudioControl = true,

  /* flikar */
  tabs = [],
  activeTab = "",
  onTabChange = () => {},
  docTabs = [],

  /* stop-knapp */
  onStopRecording = () => {},
}) => {
  /* ---------- Hjälpfunktion för flik-label ---------- */
  const labelFor = (id) => {
    if (id === "journal") return "Journal";
    if (id === "documents") return "Dokument";
    if (id === "document") return "Dokument";
    if (id === "transcription") return "Transkribering";
    if (id.startsWith("doc-")) {
      const num = id.slice(4);
      const found = docTabs.find((d) => String(d.docId) === num);
      return found ? found.title : num;
    }
    return id;
  };

  /* Om inga tabs skickas in → fallback-lista */
  const computedTabs =
    tabs.length > 0
      ? tabs
      : ["journal", "transcription"];

  return (
    <div className="top-bar">
      {/* ---------- Vänster sida: mall- & ljud-kontroller ---------- */}
      {showTemplateDropdown && (
        <div className="template-and-audio-options">
          {/* Mall-dropdown */}
          <div className="control-group">
            <label htmlFor="template-select" className="template-label">
              Välj mall:
            </label>
            <select
              id="template-select"
              className="template-select"
              onChange={(e) => onTemplateChange(parseInt(e.target.value, 10))}
              value={selectedTemplate ? selectedTemplate.template_id : ""}
              disabled={loadingTemplates}
            >
              {!selectedTemplate && (
                <option value="">-- Välj en mall --</option>
              )}
              {templates.map((tmpl) => (
                <option key={tmpl.template_id} value={tmpl.template_id}>
                  {tmpl.template_name}
                </option>
              ))}
            </select>
          </div>

          {/* Mikrofon-lista */}
          {microphones.length > 0 && (
            <div className="control-group">
              <label
                htmlFor="microphone-select"
                className="template-label"
              >
                Mikrofon:
              </label>
              <select
                id="microphone-select"
                className="microphone-select"
                onChange={(e) => onChangeMic(e.target.value)}
                value={selectedMicId}
              >
                {microphones.map((mic) => (
                  <option key={mic.deviceId} value={mic.deviceId}>
                    {mic.label || "Okänd mikrofon"}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* System-audio-toggle */}
          {showSystemAudioControl && (
            <div className="control-group">
              <label
                htmlFor="system-audio-toggle"
                className="template-label"
              >
                Digitalt möte:
              </label>
              <input
                type="checkbox"
                id="system-audio-toggle"
                checked={captureSystemAudio}
                onChange={onToggleSystemAudio}
              />
            </div>
          )}
        </div>
      )}

      {/* ---------- Flik-rad ---------- */}
      {showTabs && (
        <div className="tabs-container">
          {computedTabs.map((id) => (
            <button
              key={id}
              className={`tab-button ${activeTab === id ? "active" : ""}`}
              onClick={() => onTabChange(id)}
            >
              {labelFor(id)}
            </button>
          ))}
        </div>
      )}

      {/* ---------- Stop-knapp längst till höger ---------- */}
      {showStopButton && (
        <button className="stop-button" onClick={onStopRecording}>
          Avsluta och skapa anteckning
        </button>
      )}
    </div>
  );
};

export default TopBar;